module.exports = __webpack_public_path__ + "img/1728955885178-Screenshot_15-10-2024_93047_www.instagram.com.jpeg.c87f4d30.webp";